import General from "./Header.general";
import ShoppingCart from "./Header.shoppingCart";

export default {
  General,
  ShoppingCart
};
